export default "/fonts/vendor/@fontsource/space-grotesk/files/space-grotesk-all-500-normal.woff?1cdd094933b0a12fdad8d8e5a1c7111b";